import React from 'react';
import styles from '../../Components/Login/NotFound.module.css';

const NotFound = () => {
  return (
    <div className={styles.title}>
      <h1>404 - Página não encontrada</h1>
    </div>
  );
};

export default NotFound;
